import { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import { MultiSelect } from "react-multi-select-component";

import { LocationIcon, StatusIcon, TeamMember } from "components/assets/Icons";
import Button, { COLOR, SIZE } from "components/Button";
import UserInfo from "components/UserInfo";
import SearchSelection from "../SearchSelection";

import styles from "./Filter.module.scss";

const availabilityStatus = [
  { value: "available", label: "Available" },
  { value: "enRoute", label: "En route" },
  { value: "notAvailable", label: "Not available" },
];

const Filter = ({
  users,
  trucksList,
  setFilterResult,
  setCurrentScreen,
  setFiltered,
}) => {
  const ref = useRef();
  const [open, setOpen] = useState(true);
  const [location, setLocation] = useState({
    location: {
      title: "",
      value: "",
    },
  });
  const [selected, setSelected] = useState({
    location: { city: "", state: "", zip: "" },
    status: [],
    users: [],
  });

  const statusRenderer = (selected) => {
    if (!selected.length) {
      return <StatusIcon />;
    }

    if (selected.length > 1) {
      return (
        <>
          <StatusIcon />
          {`${selected.length} selected`}
        </>
      );
    } else if (selected.length === 1) {
      return (
        <>
          <StatusIcon />
          {selected[0]?.label}
        </>
      );
    }
  };

  const teamRenderer = (selected) => {
    if (!selected.length) {
      return <TeamMember />;
    }

    if (selected.length > 1) {
      return (
        <>
          <TeamMember /> {`${selected.length} selected`}
        </>
      );
    } else if (selected.length === 1) {
      const element = selected[0]?.label.props;
      return <UserInfo src={element.src} name={element.name} className="photo" />;
    }
  };

  const teamFilterOptions = (options, filter) => {
    if (!filter) {
      return options;
    }

    return options.filter(({ label }) => {
      return label && label?.props?.name.toLowerCase().includes(filter);
    });
  };

  const usersOptions =
    users &&
    users?.map(({ photo_url, first_name, last_name }) => {
      return {
        label: <UserInfo src={photo_url} name={first_name + " " + last_name} />,
        value: `${first_name} ${last_name}`,
      };
    });

  const handleSubmit = (e) => {
    e.preventDefault();

    setFiltered(true);

    const result = trucksList.filter((truck) => {
      return (
        (selected.location.city !== "" ||
        selected.location.state !== "" ||
        selected.location.zip !== ""
          ? selected.location.city === truck.location.city ||
            selected.location.state === truck.location.state ||
            selected.location.zip === truck.location.zip
          : true) &&
        (selected.status.length
          ? truck.availability_status &&
            selected.status.find((el) => {
              return el.label === truck.availability_status;
            })
          : true) &&
          (selected.users.length
            ? truck.associated_users_names &&
              truck.associated_users_names.some((name) => {
                return selected.users.find((el) => {
                  return el.value.toLowerCase() === name.toLowerCase();
                });
              })
          : true)
      );
    });

    setFilterResult(result);
  };

  function setHeaderHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--form-height",
        `${ref.current?.offsetHeight}px`,
      );
    }
  }

  setHeaderHeight();

  useEffect(() => {
    setHeaderHeight();
  }, [open]);

  return (
    <div className={styles.wrapper} ref={ref}>
      {open && (
        <form className={styles.form} onSubmit={handleSubmit}>
          <span className={styles.group}>
            <SearchSelection
              location={location}
              setLocation={setLocation}
              selected={selected}
              setSelected={setSelected}
              className={classnames(styles.search)}
              icon={<LocationIcon />}
            />
          </span>

          <span className={styles.group}>
            <label htmlFor="status" className={styles.label}>
              Availability Status
            </label>
            <MultiSelect
              className={classnames(styles.select)}
              options={availabilityStatus}
              value={selected.status}
              onChange={(e) => setSelected({ ...selected, status: e })}
              valueRenderer={statusRenderer}
              disableSearch={true}
            />
          </span>

          <span className={styles.group}>
            <label htmlFor="status" className={styles.label}>
              Associated User
            </label>
            <MultiSelect
              className={classnames(styles.select, styles.withPhotos)}
              options={usersOptions}
              value={selected.users}
              onChange={(e) => setSelected({ ...selected, users: e })}
              valueRenderer={teamRenderer}
              filterOptions={teamFilterOptions}
            />
          </span>

          <Button
            type="submit"
            size={SIZE.MIDDLE}
            color={COLOR.DARK}
            className={styles.submitButton}
          >
            Apply
          </Button>
        </form>
      )}
      <div className={styles.footer}>
        <button
          className={classnames(styles.toogle, styles.button, open ? styles.active : "")}
          onClick={() => setOpen(!open)}
        >
          {open ? "Hide Filters" : "Show Filters"}
        </button>
      </div>
    </div>
  );
};

export default Filter;
